var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinusCircleNotAllowed = function SvgMinusCircleNotAllowed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "inherit",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 37 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#minus-circle-not-allowed_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.75,
    cy: 16,
    r: 11.5,
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    x: 12.75,
    y: 14,
    fill: "#fff",
    stroke: "none",
    rx: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "minus-circle-not-allowed_svg__a",
    width: 36,
    height: 36,
    x: 0.75,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4448_2969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4448_2969",
    result: "shape"
  })))));
};
export default SvgMinusCircleNotAllowed;